/**
 * Inner layout for {@link ModalOverlayPanel}: grid caps height so the shell scroll + footer work.
 */
export const settingsModalDesktopPanelInnerCss = "sv5thcl";

/** Desktop shell: grid keeps nav + main pane bounded; minmax(0,1fr) prevents horizontal blowout. */
export const desktopShellCss = "d1sgij0i";
export const desktopNavCss = "dqcurt0";

/**
 * Pass-through so scroll + footer are direct grid items of `desktopShellCss`
 * (see layout_context SettingsModalContentColumn desktop variant).
 */
export const desktopContentColumnCss = "dvlffji";

/** Fixed chrome above scroll (title + close; optional people tabs). Matches Figma main-pane header. */
export const desktopPageHeaderCss = "d2zt533";
export const desktopPageHeaderTopRowCss = "d1cx0v2x";
export const desktopPageHeaderTitleCss = "dhvgo26";
export const desktopPageHeaderCloseButtonCss = "d1y3s57l";
export const desktopBodyScrollCss = "d10upur3";
export const desktopFooterHostCss = "d573t5j";

/** Portal this inside the footer host; keeps Form actions outside the scroll area. */
export const settingsModalFooterActionsCss = "s1k3f2lt";

/** Wraps rail + button so the active indicator aligns to the row. */
export const navItemRowCss = "ncok8k9";
export const navActiveRailCss = "njyocj9";
export const navItemButtonCss = "nvgumxq";
export const navItemButtonActiveCss = "n1ynmr9t";
export const navItemIconWrapCss = "n14p5fel";
export const navGroupLabelCss = "n13wuizx";
export const sectionHeaderBottomRowCss = "sc0xbpn";
export const sectionHeaderPageTabButtonCss = "s3kuvy2";
export const sectionHeaderPageTabButtonActiveCss = "siqg3fh";
export const mobileFullScreenCss = "ms4vzki";
export const mobileHeaderCss = "mtseutm";
export const mobileListCss = "m3yy0o3";
export const mobileDetailCss = "m1u1fcuc";
export const mobileDetailScrollCss = "m1167ax0";
export const mobileFooterHostCss = "m13pyrh2";
export const mobileHeaderCloseButtonCss = "m1ecrgrz";

require("./styles.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");